import './select-checkbox.scss'

import type { FC } from 'react'
import { useMemo, useState } from 'react'

import { Checkbox, Select as AntSelect, Tooltip } from 'antd'
import type { SelectProps } from 'antd/lib'

import stateIcon from 'assets/icons/state-dropdown.svg'

import { ALT_CONSTANTS } from 'common/constants/altConstants'

interface ISelectCheckBox extends SelectProps {
  label?: string
  name?: string
  options: Array<any>
  selectValue: Array<string | number> | undefined
  checkBoxLabelKey?: string
  checkBoxValueKey?: string | number
  showSelectAll?: boolean
  onChange?: (selected: Array<any>) => void
}

export const SelectCheckbox: FC<ISelectCheckBox> = ({
  label,
  name,
  options = [],
  selectValue = [],
  checkBoxLabelKey = 'label',
  checkBoxValueKey = 'value',
  showSelectAll = false,
  onChange,
  ...rest
}) => {
  const [open, setOpen] = useState(false)
  const valueArr = options
    .filter((e) => selectValue.includes(e[checkBoxValueKey]))
    .map((e) => e[checkBoxLabelKey])
    .join()

  const allOptionValues = useMemo(
    () => options.map((option) => option[checkBoxValueKey]),
    [options, checkBoxValueKey],
  )

  const isAllSelected =
    allOptionValues.length > 0 && allOptionValues.every((value) => selectValue.includes(value))
  const isSomeSelected = allOptionValues.some((value) => selectValue.includes(value))

  return (
    <>
      <label htmlFor={name} className='select-checkbox-label'>
        {label}
      </label>
      <AntSelect
        bordered={false}
        id={name}
        showSearch={false}
        value={valueArr || null}
        open={open}
        onOpenChange={(visible) => setOpen(visible)}
        suffixIcon={<img src={stateIcon} alt={ALT_CONSTANTS.STATUS} />}
        className='select-checkbox'
        dropdownRender={(originalNode) => {
          return (
            <div className='select-checkbox-container'>
              {!options.length && originalNode}
              {showSelectAll && !!options.length && (
                <div className='select-checkbox-element-container select-checkbox-select-all'>
                  <Checkbox
                    indeterminate={isSomeSelected && !isAllSelected}
                    checked={isAllSelected}
                    className='select-checkbox-element'
                    onChange={(event) => {
                      onChange?.(event.target.checked ? allOptionValues : [])
                    }}>
                    Select all
                  </Checkbox>
                </div>
              )}
              <Checkbox.Group onChange={onChange} value={selectValue}>
                {options?.map((option) => {
                  return (
                    <div
                      key={option[checkBoxValueKey]}
                      className='select-checkbox-element-container'>
                      <Tooltip title={option?.email}>
                        <Checkbox
                          value={option[checkBoxValueKey]}
                          className='select-checkbox-element'>
                          {option[checkBoxLabelKey]}
                        </Checkbox>
                      </Tooltip>
                    </div>
                  )
                })}
              </Checkbox.Group>
            </div>
          )
        }}
        {...rest}
      />
    </>
  )
}
